// Function to initialize product card functionality
function initProductCard(productId) {
    const productCard = document.querySelector(`.hoverable-product-card-${productId}`);
    if (!productCard) return;

    const images = productCard.querySelectorAll(`.product-feature-img-${productId}`);
    if (!images.length) return;

    // Store previous srcsets for all images
    let previousSrcsets = Array.from(images).map(img => img.srcset);

    const swatches = productCard.querySelectorAll('.product-swatches > span');
    swatches.forEach(swatch => {
        const vImage = swatch.dataset.vImage;
        if (!vImage) return;

        // Remove existing listeners to prevent duplicates
        swatch.removeEventListener("mouseenter", handleMouseEnter);
        swatch.removeEventListener("mouseleave", handleMouseLeave);

        function handleMouseEnter() {
            // Save current srcsets before changing
            previousSrcsets = Array.from(images).map(img => img.srcset);
            // Update all images
            images.forEach(img => {
                img.srcset = vImage;
            });
        }

        function handleMouseLeave() {
            // Restore previous srcsets to respective images
            images.forEach((img, index) => {
                img.srcset = previousSrcsets[index];
            });
        }

        swatch.addEventListener("mouseenter", handleMouseEnter);
        swatch.addEventListener("mouseleave", handleMouseLeave);
    });
}

  // Check if we're on product or collection template
  const isProductOrCollection = document.body.classList.contains('template-product') ||
                              document.body.classList.contains('template-collection');

  // Initialize observer only on product or collection pages
  if (isProductOrCollection) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains('hoverable-product-card')) {
              const productId = node.classList.toString().match(/hoverable-product-card-(\d+)/)?.[1];
              if (productId) {
                initProductCard(productId);
              }
            }
          });
        }
      });
    });

    // Observe the entire document for product cards
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup observer when page is unloaded
    window.addEventListener('unload', () => observer.disconnect());
  }

  // Initialize existing cards on page load
  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[class*="hoverable-product-card-"]').forEach(card => {
      const productId = card.classList.toString().match(/hoverable-product-card-(\d+)/)?.[1];
      if (productId) {
        initProductCard(productId);
      }
    });
  });
